export default __webpack_public_path__ + "static/media/logo_minigoal.5b2e0420.png";